
import {
  QUOTATIONS_PAGINATOR_SET_CONFIGURATION_DONE_QUOTATIONS,

  QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_REQUEST,
  QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_SUCCESS,
  QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_ERROR,
} from 'Redux/types/tableQuotationsTypes';

import { BACKEND_URL_QUOTATION } from 'Config/routes';
import { CALL_ACTIONS } from 'Redux/middleware';
import { filtersToDto } from 'Api/actions/quotation/dto/filtersDto';

// ------------------------------- ------------------------------- ------------------------------- -------------------------------
// Para poner el número de página y el Page size
const configurationQuotationsSlopes = ({ page, page_size: pageSize }) => ({
  type: QUOTATIONS_PAGINATOR_SET_CONFIGURATION_DONE_QUOTATIONS,

  page,
  page_size: pageSize,
});

export const setConfigurationQuotationsSlopes = (data) => (dispatch) => dispatch(configurationQuotationsSlopes(data));


// ------------------------------- ------------------------------- ------------------------------- -------------------------------
// quotations SLOPES | Done
const getQuotationsSlopesAction = (params) => ({
  [CALL_ACTIONS]: {
    TYPES: [
      QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_REQUEST,
      QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_SUCCESS,
      QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_ERROR,
    ],
    ENDPOINT: BACKEND_URL_QUOTATION,
    METHOD: 'GET',
    PARAMS: params,
  },
});

export const getQuotationsSlopes = ({ state }) => (dispatch, getState) => {
  const stateGeted = getState();
  const { page_size: pageSize, page } = stateGeted.tableQuotations.quotationsSlopes;
  const filterQuotations = stateGeted.tableQuotations.filtersTableQuotations;

  return (dispatch(getQuotationsSlopesAction({
    ...filtersToDto(filterQuotations),
    // vendedores: (filterQuotations.vendedores || []).join(','),
    // aseguradoras: (filterQuotations.aseguradoras || []).join(','),

    state,
    page_size: pageSize,
    page,
  })));
};
